import { CampagneReducer } from '@get/store/reducers';
import { CampagneState } from '@get/store/states';
import { CampagnePatrimoineReducer } from '@get/store/reducers';
import { CampagnePatrimoineState } from '@get/store/states';
import { CampagneSocieteCaracteristiqueReducer } from '@get/store/reducers';
import { CampagneSocieteCaracteristiqueState } from '@get/store/states';
import { CampagneUserReducer } from '@get/store/reducers';
import { CampagneUserState } from '@get/store/states';
import { CaracteristiqueTemplateReducer } from '@get/store/reducers';
import { CaracteristiqueTemplateState } from '@get/store/states';
import { CaracteristiqueChoixTemplateReducer } from '@get/store/reducers';
import { CaracteristiqueChoixTemplateState } from '@get/store/states';
import { ComposantReducer } from '@get/store/reducers';
import { ComposantState } from '@get/store/states';
import { ComposantAttenduReducer } from '@get/store/reducers';
import { ComposantAttenduState } from '@get/store/states';
import { ComposantGroupeReducer } from '@get/store/reducers';
import { ComposantGroupeState } from '@get/store/states';
import { ComposantTemplateReducer } from '@get/store/reducers';
import { ComposantTemplateState } from '@get/store/states';
import { DroitReducer } from '@get/store/reducers';
import { DroitState } from '@get/store/states';
import { EspaceReducer } from '@get/store/reducers';
import { EspaceState } from '@get/store/states';
import { FichierReducer } from '@get/store/reducers';
import { FichierState } from '@get/store/states';
import { NewsletterReducer } from '@get/store/reducers';
import { NewsletterState } from '@get/store/states';
import { OrganisationAzureLoginReducer } from '@get/store/reducers';
import { OrganisationAzureLoginState } from '@get/store/states';
import { OrganisationReducer } from '@get/store/reducers';
import { OrganisationState } from '@get/store/states';
import { OrganisationNewsletterReducer } from '@get/store/reducers';
import { OrganisationNewsletterState } from '@get/store/states';
import { PatrimoineReducer } from '@get/store/reducers';
import { PatrimoineState } from '@get/store/states';
import { PatrimoineAncetreReducer } from '@get/store/reducers';
import { PatrimoineAncetreState } from '@get/store/states';
import { PatrimoineHierarchieTemplateReducer } from '@get/store/reducers';
import { PatrimoineHierarchieTemplateState } from '@get/store/states';
import { SocieteReducer } from '@get/store/reducers';
import { SocieteState } from '@get/store/states';
import { SocieteCaracteristiqueReducer } from '@get/store/reducers';
import { SocieteCaracteristiqueState } from '@get/store/states';
import { SocieteCaracteristiqueChoixReducer } from '@get/store/reducers';
import { SocieteCaracteristiqueChoixState } from '@get/store/states';
import { SocieteConfigAnalyseSyntheseReducer } from '@get/store/reducers';
import { SocieteConfigAnalyseSyntheseState } from '@get/store/states';
import { SocieteConfigAnalyseSyntheseSocieteCaracteristiqueReducer } from '@get/store/reducers';
import { SocieteConfigAnalyseSyntheseSocieteCaracteristiqueState } from '@get/store/states';
import { SocieteComposantReducer } from '@get/store/reducers';
import { SocieteComposantState } from '@get/store/states';
import { SocieteComposantFamilleReducer } from '@get/store/reducers';
import { SocieteComposantFamilleState } from '@get/store/states';
import { SocieteComposantRattachementReducer } from '@get/store/reducers';
import { SocieteComposantRattachementState } from '@get/store/states';
import { SocieteEspaceReducer } from '@get/store/reducers';
import { SocieteEspaceState } from '@get/store/states';
import { SocieteEspaceFamilleReducer } from '@get/store/reducers';
import { SocieteEspaceFamilleState } from '@get/store/states';
import { SocietePatrimoineHierarchieReducer } from '@get/store/reducers';
import { SocietePatrimoineHierarchieState } from '@get/store/states';
import { SocietePatrimoineHierarchieAncetreReducer } from '@get/store/reducers';
import { SocietePatrimoineHierarchieAncetreState } from '@get/store/states';
import { SocieteProfilReducer } from '@get/store/reducers';
import { SocieteProfilState } from '@get/store/states';
import { SocieteProfilDroitReducer } from '@get/store/reducers';
import { SocieteProfilDroitState } from '@get/store/states';
import { SocieteTerritoireReducer } from '@get/store/reducers';
import { SocieteTerritoireState } from '@get/store/states';
import { SocieteTerritoirePatrimoineReducer } from '@get/store/reducers';
import { SocieteTerritoirePatrimoineState } from '@get/store/states';
import { SocieteTerritoireUserReducer } from '@get/store/reducers';
import { SocieteTerritoireUserState } from '@get/store/states';
import { UserReducer } from '@get/store/reducers';
import { UserState } from '@get/store/states';
import { UserNewsletterReducer } from '@get/store/reducers';
import { UserNewsletterState } from '@get/store/states';
import { UserPatrimoineReducer } from '@get/store/reducers';
import { UserPatrimoineState } from '@get/store/states';
import { UserSocieteProfilReducer } from '@get/store/reducers';
import { UserSocieteProfilState } from '@get/store/states';
import { ValeurReducer } from '@get/store/reducers';
import { ValeurState } from '@get/store/states';
import { ValeurFichierReducer } from '@get/store/reducers';
import { ValeurFichierState } from '@get/store/states';
import { ValeurComposantReducer } from '@get/store/reducers';
import { ValeurComposantState } from '@get/store/states';
import { ValeurPatrimoineReducer } from '@get/store/reducers';
import { ValeurPatrimoineState } from '@get/store/states';

export interface GeneratedAppState {
  campagne: CampagneState.IState;
  campagnePatrimoine: CampagnePatrimoineState.IState;
  campagneSocieteCaracteristique: CampagneSocieteCaracteristiqueState.IState;
  campagneUser: CampagneUserState.IState;
  caracteristiqueTemplate: CaracteristiqueTemplateState.IState;
  caracteristiqueChoixTemplate: CaracteristiqueChoixTemplateState.IState;
  composant: ComposantState.IState;
  composantAttendu: ComposantAttenduState.IState;
  composantGroupe: ComposantGroupeState.IState;
  composantTemplate: ComposantTemplateState.IState;
  droit: DroitState.IState;
  espace: EspaceState.IState;
  fichier: FichierState.IState;
  newsletter: NewsletterState.IState;
  organisationAzureLogin: OrganisationAzureLoginState.IState;
  organisation: OrganisationState.IState;
  organisationNewsletter: OrganisationNewsletterState.IState;
  patrimoine: PatrimoineState.IState;
  patrimoineAncetre: PatrimoineAncetreState.IState;
  patrimoineHierarchieTemplate: PatrimoineHierarchieTemplateState.IState;
  societe: SocieteState.IState;
  societeCaracteristique: SocieteCaracteristiqueState.IState;
  societeCaracteristiqueChoix: SocieteCaracteristiqueChoixState.IState;
  societeConfigAnalyseSynthese: SocieteConfigAnalyseSyntheseState.IState;
  societeConfigAnalyseSyntheseSocieteCaracteristique: SocieteConfigAnalyseSyntheseSocieteCaracteristiqueState.IState;
  societeComposant: SocieteComposantState.IState;
  societeComposantFamille: SocieteComposantFamilleState.IState;
  societeComposantRattachement: SocieteComposantRattachementState.IState;
  societeEspace: SocieteEspaceState.IState;
  societeEspaceFamille: SocieteEspaceFamilleState.IState;
  societePatrimoineHierarchie: SocietePatrimoineHierarchieState.IState;
  societePatrimoineHierarchieAncetre: SocietePatrimoineHierarchieAncetreState.IState;
  societeProfil: SocieteProfilState.IState;
  societeProfilDroit: SocieteProfilDroitState.IState;
  societeTerritoire: SocieteTerritoireState.IState;
  societeTerritoirePatrimoine: SocieteTerritoirePatrimoineState.IState;
  societeTerritoireUser: SocieteTerritoireUserState.IState;
  user: UserState.IState;
  userNewsletter: UserNewsletterState.IState;
  userPatrimoine: UserPatrimoineState.IState;
  userSocieteProfil: UserSocieteProfilState.IState;
  valeur: ValeurState.IState;
  valeurFichier: ValeurFichierState.IState;
  valeurComposant: ValeurComposantState.IState;
  valeurPatrimoine: ValeurPatrimoineState.IState;
}

export const generatedAppState = {
  campagne: CampagneReducer.reducer,
  campagnePatrimoine: CampagnePatrimoineReducer.reducer,
  campagneSocieteCaracteristique: CampagneSocieteCaracteristiqueReducer.reducer,
  campagneUser: CampagneUserReducer.reducer,
  caracteristiqueTemplate: CaracteristiqueTemplateReducer.reducer,
  caracteristiqueChoixTemplate: CaracteristiqueChoixTemplateReducer.reducer,
  composant: ComposantReducer.reducer,
  composantAttendu: ComposantAttenduReducer.reducer,
  composantGroupe: ComposantGroupeReducer.reducer,
  composantTemplate: ComposantTemplateReducer.reducer,
  droit: DroitReducer.reducer,
  espace: EspaceReducer.reducer,
  fichier: FichierReducer.reducer,
  newsletter: NewsletterReducer.reducer,
  organisationAzureLogin: OrganisationAzureLoginReducer.reducer,
  organisation: OrganisationReducer.reducer,
  organisationNewsletter: OrganisationNewsletterReducer.reducer,
  patrimoine: PatrimoineReducer.reducer,
  patrimoineAncetre: PatrimoineAncetreReducer.reducer,
  patrimoineHierarchieTemplate: PatrimoineHierarchieTemplateReducer.reducer,
  societe: SocieteReducer.reducer,
  societeCaracteristique: SocieteCaracteristiqueReducer.reducer,
  societeCaracteristiqueChoix: SocieteCaracteristiqueChoixReducer.reducer,
  societeConfigAnalyseSynthese: SocieteConfigAnalyseSyntheseReducer.reducer,
  societeConfigAnalyseSyntheseSocieteCaracteristique: SocieteConfigAnalyseSyntheseSocieteCaracteristiqueReducer.reducer,
  societeComposant: SocieteComposantReducer.reducer,
  societeComposantFamille: SocieteComposantFamilleReducer.reducer,
  societeComposantRattachement: SocieteComposantRattachementReducer.reducer,
  societeEspace: SocieteEspaceReducer.reducer,
  societeEspaceFamille: SocieteEspaceFamilleReducer.reducer,
  societePatrimoineHierarchie: SocietePatrimoineHierarchieReducer.reducer,
  societePatrimoineHierarchieAncetre: SocietePatrimoineHierarchieAncetreReducer.reducer,
  societeProfil: SocieteProfilReducer.reducer,
  societeProfilDroit: SocieteProfilDroitReducer.reducer,
  societeTerritoire: SocieteTerritoireReducer.reducer,
  societeTerritoirePatrimoine: SocieteTerritoirePatrimoineReducer.reducer,
  societeTerritoireUser: SocieteTerritoireUserReducer.reducer,
  user: UserReducer.reducer,
  userNewsletter: UserNewsletterReducer.reducer,
  userPatrimoine: UserPatrimoineReducer.reducer,
  userSocieteProfil: UserSocieteProfilReducer.reducer,
  valeur: ValeurReducer.reducer,
  valeurFichier: ValeurFichierReducer.reducer,
  valeurComposant: ValeurComposantReducer.reducer,
  valeurPatrimoine: ValeurPatrimoineReducer.reducer,
};
